// components/Admin.jsx
import React, { useContext } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const Admin = () => {
  const { logout, username } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    try {
      logout?.();
    } finally {
      navigate('/login', { replace: true });
    }
  };

  const linkBase =
    'px-4 py-2 rounded-md text-sm font-medium border transition shadow-sm';
  const linkInactive =
    'text-gray-700 bg-white border-gray-300 hover:bg-gray-50';
  const linkActive =
    'text-white bg-indigo-600 border-indigo-600 hover:bg-indigo-700';

  const navLinkClasses = ({ isActive }) =>
    `${linkBase} ${isActive ? linkActive : linkInactive}`;

  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      {/* Frame superior */}
      <header className="w-full bg-white border-b">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center gap-3">
          <h1 className="text-lg font-semibold text-gray-900 mr-auto">
            Admin UNIMEL
          </h1>

          <nav className="flex items-center gap-2">
            <NavLink to="cursos" className={navLinkClasses}>
              Cursos
            </NavLink>
            <NavLink to="alumnos" className={navLinkClasses}>
              Alumnos
            </NavLink>
            <NavLink to="report" className={navLinkClasses}>
              Report
            </NavLink>
            <NavLink to="vector-files" className={navLinkClasses}>
              VectorDB
            </NavLink>
            {/* NUEVO: botón para uploader del Vector Store */}
            <NavLink to="vector-uploader" className={navLinkClasses}>
              UPLOADVECTORSTORE
            </NavLink>
          </nav>

          <div className="ml-3 flex items-center gap-3">
            {username ? (
              <span className="text-sm text-gray-500 hidden sm:inline">
                {username}
              </span>
            ) : null}
            <button
              onClick={handleLogout}
              className="px-4 py-2 rounded-md text-sm font-medium text-white bg-rose-600 hover:bg-rose-700 shadow-sm"
              aria-label="Cerrar sesión"
            >
              Logout
            </button>
          </div>
        </div>
      </header>

      {/* Frame inferior: contenido enrutado */}
      <main className="flex-1">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Admin;
